import React, { Fragment } from "react";
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import HistoryIcon from '@mui/icons-material/History';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useAlert } from 'react-alert';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutUser, loadUser } from "./Actions/userAction";
import { DashboardRounded } from "@mui/icons-material";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import { Box, Typography } from "@mui/material";

const UserOptions = () => {
  const alert = useAlert();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);

  const removeUser = () => {
    dispatch(logoutUser())
      .then(() => {
        alert.success("Logout Successful");
        dispatch(loadUser());
        navigate("/login");
      })
      .catch((error) => {
        console.error("Logout failed:", error);
      });
  };

  const handleShare = () => {
    if (user.role_name === 'user') {
      navigate("/account/donations");
    } else {
      navigate("/dashboard");
    }
  };

  const actions = [
    {
      icon: <ExitToAppIcon sx={{ color: 'error.main' }} />,
      name: 'LogOut',
      fun: removeUser,
    },
    {
      icon: user.role_name === 'user'
        ? <HistoryIcon sx={{ color: 'primary.main' }} />
        : <DashboardRounded sx={{ color: 'success.main' }} />,
      name: user.role_name === 'user' ? 'Donation History' : 'Dashboard',
      fun: handleShare,
    },
    {
      icon: <VolunteerActivismIcon sx={{ color: "secondary.main" }} />,
      name: "Donate Now",
      fun: () => navigate("/"),
    },
  ];

  return (
    <Fragment>
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center',   // vertically center
          position: 'relative', 
          top: 90, 
          mr: 3, 
          zIndex: 1300 
        }}
      >
        {/* SpeedDial FAB */}
        <SpeedDial
          ariaLabel="User Options"
          icon={<AccountCircleIcon />}
          direction="down"
          sx={{
            "& .MuiFab-primary": {
              backgroundColor: "#f5f5f5", // neutral gray
              color: "#555",              // gray icon
              width: 56,
              height: 56,
              minHeight: 56,
              "&:hover": {
                backgroundColor: "#e0e0e0",
              },
            },
          }}
        >
          {actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              onClick={action.fun}
            />
          ))}
        </SpeedDial>

      </Box>
    </Fragment>
  );
};

export default UserOptions;
